import { render, staticRenderFns } from "./AttachmentsUploadDialog.vue?vue&type=template&id=b0da3104&scoped=true"
import script from "./AttachmentsUploadDialog.vue?vue&type=script&lang=ts"
export * from "./AttachmentsUploadDialog.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentsUploadDialog.vue?vue&type=style&index=0&id=b0da3104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0da3104",
  null
  
)

export default component.exports